import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { delay, finalize } from 'rxjs';
import { BusyService } from '../services/busy.service';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const busyService = inject(BusyService);

  if (req.method === 'GET') {
    busyService.busy();
  }

  return next(req).pipe(
    delay(1000), // Optional delay (remove if not needed)
    finalize(() => {
      if (req.method === 'GET') {
        busyService.idle(); // Only idle if it was a GET request
      }
    })
  );
};
